import { Handle, Position } from "reactflow";

const CustomNode = ({ data }) => {
  return (
    <div
      style={{
        background: data.style.background,
        color: data.style.color,
        border: data.style.border,
        borderRadius: data.style.borderRadius,
        fontFamily: data.style.fontFamily,
        padding: data.style.padding,
        fontSize: data.style.fontSize,
        fontWeight: data.style.fontWeight,
        whiteSpace: data.style.whiteSpace,
        textAlign: data.style.textAlign,
        minWidth: data.style.minWidth,
        width: data.style.width,
        height: data.style.height,
      }}
    >
      {/* Left handles */}
      <Handle type="source" position={Position.Left} id="left" />
      <Handle type="target" position={Position.Left} id="left-target" />
      <Handle
        type="target"
        position={Position.Left}
        id="left-target-1"
        style={{ top: "30%" }}
      />
      <Handle
        type="target"
        position={Position.Left}
        id="left-target-2"
        style={{ top: "70%" }}
      />

      <Handle
        type="source"
        position={Position.Top}
        id="top"
        style={{ left: "30%" }}
      />
      <Handle
        type="target"
        position={Position.Top}
        id="top-target"
        style={{ left: "70%" }}
      />
      <Handle
        type="target"
        position={Position.Top}
        id="top-target-left"
        style={{ left: "30%" }}
      />
      <Handle
        type="source"
        position={Position.Top}
        id="top-source-right"
        style={{ left: "70%" }}
      />

      <Handle type="source" position={Position.Right} id="right" />

      <Handle type="source" position={Position.Bottom} id="bottom" />
      <Handle
        type="target"
        position={Position.Bottom}
        id="bottom-target-1"
        style={{ left: "26%" }}
      />
      <Handle
        type="target"
        position={Position.Bottom}
        id="bottom-target-2"
        style={{ left: "75%" }}
      />

      {data.label}
    </div>
  );
};

export default CustomNode;
